import { useSearchParams } from 'react-router-dom';

export const useGetJobId = (): string | undefined => {
  const [searchParams] = useSearchParams();
  return searchParams.get('job') || undefined;
};
